import React from 'react';
import FlatButton from 'material-ui/FlatButton';
/* eslint-disable */
class Bookings extends React.Component {
	render() {
    const { body, open } = this.props;
		return (
      <div
        className="main-content-body-inner-container"
        style={{ display: open ? 'block' : 'none' }}
      >
        <div className="main-content-body-title">
          BOOKINGS
        </div>
        <div className="main-content-text-container main-content-body-scrollable-box">
          {body ? (
            <div
              className="body-html-box"
              dangerouslySetInnerHTML={{ __html: body }}
            />
          ) : null}
          {/* <div className="body-html-box" style={{ marginTop: 20 }}>
            <p style={{ fontWeight: 'bold' }}>
              * Our online booking platform is temporarily down. Please call between 10am and 6pm for any enquiries. Alternatively, check back here in 24 hours. We are sorry for the inconvenience.
            </p>
          </div> */}
          <div style={{ textAlign: 'center' }}>
            <div
              style={{
                border: '2px solid #132f17',
                display: 'inline-block',
                margin: '8px 0px',
                width: '100%',
                maxWidth: 360,
              }}>
              <FlatButton
                fullWidth
                label="FIND A TABLE"
                href="https://www.sevenrooms.com/reservations/samesame/booking-widget-same-same?venues=samesame,honto,agnesrestaurant,biancarestaurant"
                target="_blank"          
                labelStyle={{ textTransform: 'none' }}
                style={{ lineHeight: '40px', height: 40 }}
              />
            </div>
          </div>
        </div>
			</div>
		);
	}
}

export default Bookings;



// WEBPACK FOOTER //
// ./src/Theme/Bookings.jsx